import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { determineAccountLanguageGuard } from '../../guards/account/determineAccountLanguageGuard';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';

import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

const errorPageGuardArray = [determineAccountLanguageGuard, determineI18nResourceGuard];

export const generateErrorPageGuards = (): Guard<BaseState> => {
  return combineGuardsSerial(errorPageGuardArray);
};
